import React, { useState, useEffect } from 'react';
import './TerminalHeader.css';

const LINES = [
  { prompt: true, cmd: 'cat about.md' },
  { prompt: false, out: 'SRE at SITA · DevOps Engineer · Cloud Architect · CNCF Jordan Organizer', hi: true },
  { prompt: false, out: 'Ten years keeping critical infrastructure alive — airports, airlines, border control.' },
  { prompt: false, out: 'Systems that cannot go down. Platforms built to hold.', dim: true },
];

export default function TerminalHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  return (
    <header className={`term-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="term-titlebar">
        <div className="term-dots">
          <span className="dot red" />
          <span className="dot yellow" />
          <span className="dot green" />
        </div>
        <div className="term-hostname">shahd@sita:~</div>
        <nav className="term-nav">
          <a href="#work">work</a>
          <a href="#journey">journey</a>
          <a href="#consulting">consulting</a>
          <a href="#community">community</a>
          <a href="#contact" className="term-nav-cta">hire me</a>
        </nav>
      </div>
      <div className="term-output">
        {LINES.map((l, i) => (
          <div key={i} className={`term-line ${l.hi ? 'hi' : ''} ${l.dim ? 'dim' : ''}`}>
            {l.prompt && <span className="term-prompt">shahd@sita:~$</span>}
            {l.prompt && <span className="term-cmd">{l.cmd}</span>}
            {!l.prompt && <span className="term-out">{l.out}</span>}
          </div>
        ))}
      </div>
    </header>
  );
}
